import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { map, switchMap, switchMapTo, tap, withLatestFrom } from 'rxjs/operators';
import { filterNotNullish } from '@app/core/utils/rxjs';

import * as InputsActions from './actions';
import * as InputsSelectors from './selectors';
import * as ShippingPricesActions from '../prices/actions';

@Injectable()
export class InputsEffects {
	// setLanguage$ = createEffect(() => {
	// 	return this.actions$.pipe(
	// 		ofType(InputsActions.setLanguage),
	// 		withLatestFrom(this.store.select(InputsSelectors.selectLanguage)),
	// 		map(([action, lang]) => lang),
	// 		tap(console.log),
	// 		filterNotNullish()
	// 		// switchMapTo([
	// 		// 	// EMPTY,
	// 		// 	ShippingPricesActions.load()
	// 		// ])
	// 	);
	// });

	constructor(private actions$: Actions, private store: Store) {}
}
